import { useEffect, useState } from 'react';

const notFoundCounts = new Map();
const listeners = new Set();

const notify = () => {
  const hasNotFound = notFoundCounts.size > 0;
  listeners.forEach((listener) => listener(hasNotFound));
};

export const hasImageNotFound = () => notFoundCounts.size > 0;

export const reportImageNotFound = (src) => {
  const count = notFoundCounts.get(src) || 0;
  notFoundCounts.set(src, count + 1);
  if (count === 0) {
    notify();
  }
};

export const clearImageNotFound = (src) => {
  const count = notFoundCounts.get(src);
  if (!count) {
    return;
  }
  if (count > 1) {
    notFoundCounts.set(src, count - 1);
    return;
  }
  notFoundCounts.delete(src);
  notify();
};

export const resetImageNotFound = () => {
  notFoundCounts.clear();
  notify();
};

export const useHasImageNotFound = () => {
  const [hasNotFound, setHasNotFound] = useState(hasImageNotFound());

  useEffect(() => {
    listeners.add(setHasNotFound);
    setHasNotFound(hasImageNotFound());
    return () => {
      listeners.delete(setHasNotFound);
    };
  }, []);

  return hasNotFound;
};
